import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { MdVisibility } from "react-icons/md";
import CustomToggle from '../../component/CustomToggle';
import {
    useLibrarySync, UnsyncedCategoriesDialog, SyncedAtSourceCell, SyncLoadingCell, ReadOnlyActionsCell,
} from '../AssignmentMatrixLibrary/LibrarySync';

/**
 * Sync wiring for the two tutorial tables. Each tutorial has its own switch;
 * the server answers status and toggles in the same shape as the library, so
 * the library hook does the work. Status rows are keyed by quiz_id.
 *
 * The switch is for the same superadmins as library sync (/amlSyncSwitch).
 */
export const useTutorialSync = () => useLibrarySync({
    statusUrl: '/tutorialSyncStatus',
    toggleUrl: '/tutorialSyncEnable',
});

/**
 * The Sync column. A tutorial received from another university has no switch
 * here - its owner pushes it - so it links to the owner instead.
 */
export const tutorialSyncColumn = (tutorialSync) => ({
    id: 'sync',
    name: <div className='sf-data-table-header'>Sync</div>,
    sortable: false,
    width: '160px',
    cell: (row) => {
        const syncInfo = tutorialSync.getSyncInfo(row.quiz_id);

        if (row.is_synced || syncInfo.is_synced) {
            return <SyncedAtSourceCell
                lookupUrl='/tutorialSourceUnivUrl'
                lookupData={{ quiz_id: row.quiz_id }}
                sourcePath='tutorialsAndExplanations'
            />;
        }
        if (tutorialSync.syncStatusLoading) {
            return <SyncLoadingCell />;
        }
        return (
            <div style={{ marginTop: "8px" }}>
                <CustomToggle
                    Enabled={syncInfo.enable_sync || false}
                    tristate={false}
                    onEnableChecked={() => tutorialSync.toggleSync(row.quiz_id, true, { quiz_id: row.quiz_id })}
                    onDisableChecked={() => tutorialSync.toggleSync(row.quiz_id, false, { quiz_id: row.quiz_id })}
                    onHandleMiddleredirect={() => { }}
                    syncStatus={syncInfo.sync_status_code || 0}
                    sourceRedirect={false}
                    type="switch"
                    id={"switch-tutorial-" + row.quiz_id}
                />
            </div>
        );
    },
});

export const TutorialUnsyncedDialog = ({ tutorialSync }) => (
    <UnsyncedCategoriesDialog
        unsyncedCategories={tutorialSync.unsyncedCategories}
        onClose={tutorialSync.clearUnsyncedCategories}
        showMatrix={false}
        description="This tutorial uses question bank rows that are missing on the other universities. Sync them from the question bank first, then enable sync for this tutorial."
    />
);

/**
 * Actions for a tutorial received from another university: it can be opened to
 * see what is inside, but only its owner changes it.
 */
export const ReceivedTutorialActionsCell = ({ onView }) => (
    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <Tooltip title="View" arrow placement="top">
            <IconButton onClick={onView}>
                <MdVisibility color='#3d5e9c' />
            </IconButton>
        </Tooltip>
        <ReadOnlyActionsCell />
    </div>
);
